import { createContext, useContext } from "react";
export function useToast() {
    return useContext(ToastContext);
}
const ToastContext = createContext(() => { });
export { ToastContext };
//# sourceMappingURL=ToastContext.js.map